import { Icon } from '@iconify/react';

import { ContentDataWithProgress, SectionDataWithProgress } from '../../../types/compound/progressTypes';
import SectionData from '../../../types/SectionData';
import ContentTypeIcon from '../../atoms/content-type-icon/ContentTypeIcon';

import './SectionRow.scss';
import ContentService from '../../../services/contentService';

interface ActiveSectionRowProps {
  section: SectionDataWithProgress | SectionData;
  contents: ContentDataWithProgress[];
  className?: string;
  currentContentId?: string;
}

export default function ActiveSectionRow({
  section,
  contents,
  className = '',
  currentContentId,
}: ActiveSectionRowProps) {
  const ContentListRows = contents.map(content => {
    return (
      <li
        key={content.id}
        className={`content-row flex justify-between items-center ${content.complete ? 'complete' : ''} ${
          currentContentId === content.id && 'active'
        }`}
      >
        <p className="overflow-hidden whitespace-nowrap text-ellipsis">{ContentService.getContentRowText(content)}</p>
        <ContentTypeIcon className="mr-1" type={content.type} />
      </li>
    );
  });

  return (
    <div className={`section-row ${className}`}>
      <div className="flex">
        <span className={`name active px-8 py-2`}>{section.name}</span>
        {'complete' in section && section.complete && (
          <Icon className="check ml-auto mr-16" icon="material-symbols:done" />
        )}
      </div>
      <ol className="">{ContentListRows}</ol>
    </div>
  );
}
